import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/taskcenter/import';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 2022/2/20 10:09 任务列表
        _this.taskList = [];
        _this.loading = false;
        _this.taskData = {};
        _this.title = ''; // 2022/2/21 21:08 标题
        return _this;
    }
    View.prototype.created = function () {
        var _this = this;
        ;
        window['doReloadData'] = function () {
            _this.doReloadData();
        };
        this.loading = true;
        this.getTask();
    };
    // 2022/2/16 15:22 获取任务列表
    View.prototype.getTask = function () {
        var _this = this;
        this.taskList = [];
        PageService.getTaskList({})
            .then(function (data) {
            _this.taskData = data;
            _this.taskData.img = data.sex == 2 ? 1 : 2;
            _this.loading = false;
            _this.title = data.sex == 2 ? '赚现金' : '赚钻石';
            if (data.rookie.length != 0) {
                _this.taskList.push({
                    title: '新手任务',
                    children: data.rookie,
                });
            }
            if (data.daily.length != 0) {
                _this.taskList.push({
                    title: '每日任务',
                    children: data.daily,
                });
            }
        })
            .catch(function () {
            _this.loading = false;
        });
    };
    // 2022/2/16 15:47 完成任务
    View.prototype.finishTask = function (row) {
        // 2022/2/18 20:30 判断是否跳转H5页面。。。若不是H5 则调用原生方法
        if (row.uri.indexOf('tata:') == -1) {
            var params = {
                navH: this.awlGlobalState.urlInitParams.navH,
                statusH: this.awlGlobalState.urlInitParams.statusH,
                version: this.awlGlobalState.urlInitParams.version,
                token: this.awlGlobalState.urlInitParams.token,
            };
            this.$router.push({
                path: row.uri,
                query: params,
            });
        }
        else {
            var params = {
                route: row.uri,
                action: 0,
            };
            this.awlGlobalConfig.messageHandlers(params);
        }
    };
    // 2022/2/16 15:50 原生调用H5方法
    View.prototype.doReloadData = function () {
        this.taskList = [];
        this.getTask();
    };
    View = __decorate([
        Options({
            components: {},
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
